import { createStyles, getStylesRef } from '@mantine/core'

import { hexToRgb, hsbToRgb, rgbToHsb } from 'utils/colors'

import { Props } from '.'

type StylesParams = {
  size: Props['size']
  color?: string
}

export default createStyles((theme, { size, color = '' }: StylesParams) => {
  const rgb: any = hexToRgb(color, true)
  const hsb = rgbToHsb(rgb.r, rgb.g, rgb.b)
  const newPattern1 = hsbToRgb(hsb[0], hsb[1] * 0.15, 98)
  const hoverColor = `rgb(${newPattern1[0]},${newPattern1[1]},${newPattern1[2]})`
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      padding: 8,
      gap: size === 'lg' ? 12 : 8,
      background: '#fff',
      borderRadius: 8,
      ...(size === 'md' && {
        flexDirection: 'column',
        alignItems: 'stretch',
      }),
      [theme.fn.largerThan('sm')]: {
        gap: size === 'lg' ? 24 : 12,
        padding: size === 'lg' ? 16 : 12,
        '&:hover': {
          [`.${getStylesRef('name')}`]: {
            color,
          },
          [`.${getStylesRef('hospitalInfo')}`]: {
            backgroundColor: hoverColor,
          },
          hoverColor,
        },
      },
    },
    thumbCol: {
      ...(size === 'md' && {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        gap: 12,
      }),
    },
    thumb: {
      display: 'block',
      flexShrink: 0,
      position: 'relative',
      img: {
        borderRadius: 8,
      },
    },
    nameAreaSmSize: {
      ...(size === 'lg' && {
        display: 'none',
      }),
    },
    nameAreaLgSize: {
      ...(size === 'md' && {
        display: 'none',
      }),
    },
    name: {
      ref: getStylesRef('name'),
    },
    info: {
      display: 'flex',
      flexDirection: 'column',
      gap: size === 'lg' ? 8 : 4,
      ...(size === 'md' && {
        height: '100%',
      }),
    },
    hospitalInfo: {
      ref: getStylesRef('hospitalInfo'),
      borderRadius: size === 'lg' ? 8 : 4,
      backgroundColor: theme.colors.neutral[0],
      padding: size === 'lg' ? 8 : 6,
      transition: 'all .3s ease',
      ...(size === 'md' && {
        height: '100%',
      }),
    },
    cta: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      paddingTop: 5,
    },
    expertIcon: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      bottom: 0,
      right: 0,
      backgroundColor: '#fff',
      borderTopLeftRadius: 6,
      width: 16,
      height: 16,
      [theme.fn.largerThan('sm')]: {
        width: size === 'lg' ? 40 : 16,
        height: size === 'lg' ? 40 : 16,
      },
      img: {
        width: 12,
        height: 12,
        [theme.fn.largerThan('sm')]: {
          width: size === 'lg' ? 28 : 12,
          height: size === 'lg' ? 28 : 12,
        },
      },
    },
  }
})
